import { Button } from "@/components/ui/button";

export function PublicTaskPager({
	page,
	limit,
	total,
	loading,
	onPageChange,
}: {
	page: number;
	limit: number;
	total: number;
	loading: boolean;
	onPageChange: (page: number) => void;
}) {
	const from = total ? (page - 1) * limit + 1 : 0;
	const to = Math.min(page * limit, total);

	return (
		<div className="mt-4 flex items-center justify-between gap-4 text-xs text-muted">
			<span>{loading ? "Loading..." : `Showing ${from}-${to} of ${total}`}</span>
			<div className="flex gap-2">
				<Button
					variant="outline"
					size="sm"
					disabled={page <= 1}
					onClick={() => onPageChange(page - 1)}
				>
					Previous
				</Button>
				<Button
					variant="outline"
					size="sm"
					disabled={to >= total}
					onClick={() => onPageChange(page + 1)}
				>
					Next
				</Button>
			</div>
		</div>
	);
}
